module.exports = __webpack_public_path__ + "static/media/github.75da901d.svg";